import React from 'react';

import { requestPost, } from '../../../../modules/request/index';

export default class UnmergeClasses extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      secondaryClassCode: '',
      submitting: false
    }
  }

  submitData = () => {
    const that = this

    this.setState({ submitting: true, error: null })
    requestPost(
      `${window.postbuildEnv.DEFAULT_URL}/teacher_fix/unmerge_classes`,
      { secondary_class_code: that.state.secondaryClassCode },
      (body) => {
        if (body.error) {
          that.setState({ submitting: false, error: body.error })
        } else {
          that.setState({ submitting: false, error: null })
          window.alert('Classes have been unmerged!')
        }
      },
      (body) => {
        that.setState({ submitting: false, error: body.error || 'Something went wrong. Please check whether the unmerge completed before retrying.' })
      }
    ).catch(() => {
      that.setState({ submitting: false, error: 'Something went wrong. Please check whether the unmerge completed before retrying.' })
    })
  };

  updateSecondaryClassCode = (e) => {
    this.setState({ secondaryClassCode: e.target.value })
  };

  renderError() {
    if (this.state.error) {
      return <p className="error">{this.state.error}</p>
    }
  }

  render() {
    return (
      <div>
        <h1><a href="/teacher_fix">Teacher Fixes</a></h1>
        <h2>Unmerge Provider-Synced Classes</h2>
        <p>Reverses a merge created with the <a href="/teacher_fix/merge_classes">Merge Provider-Synced Classes</a> fix. Enter the code of the secondary (nested) class. The secondary class is detached from the primary class, and the students it added to the primary class are removed, restoring the primary class's roster from before the merge.</p>
        <div>
          <div className="input-row">
            <label htmlFor="secondary-class-code">Secondary Class Code:</label>
            <input id="secondary-class-code" onChange={this.updateSecondaryClassCode} type="text" value={this.state.secondaryClassCode} />
          </div>
          <button disabled={this.state.submitting} onClick={this.submitData} type="button">
            {this.state.submitting ? 'Unmerging… (this can take a minute)' : 'Unmerge Classes'}
          </button>
          {this.renderError()}
        </div>
      </div>
    )
  }
}
